import "./ComparisonTools.module.css";
import Header from "@/reusable_sections/Header";
import ToolInterface from "./sections/ToolInterface";
import DownloadCta from "./sections/DownloadCta";
import Footer from "@/reusable_sections/Footer";
export default function ComparisonToolsPage() {
  return <div>
      <Header />
      <ToolInterface />
      <DownloadCta />
      <Footer />
    </div>;
}